export default {
  order_management: ['order_management'],
  order_add: ['order_add'],
  order_edit: ['order_edit'],
  order_status: ['order_edit'],
  order_delete: ['order_delete'],
  order_archive: ['order_archive'],
  order_activity: ['order_activity'],

  order_history_management: ['order_history_management'],

  order_document_management: ['order_document_management'],
  order_document_add: ['order_document_add'],
  order_document_edit: ['order_document_edit'],
  order_document_delete: ['order_document_delete'],
  order_document_archive: ['order_document_archive'],

  order_request_management: ['order_request_management'],
  order_request_add: ['order_request_add'],
  order_request_edit: ['order_request_edit'],
  order_request_status: ['order_request_edit'],
  order_request_delete: ['order_request_delete'],

  order_request_history_management: ['order_request_history_management'],

  order_allotment: ['order_allotment'],
  order_allotment_add: ['order_allotment', 'order_allotment_add']
}
